module.exports = __webpack_public_path__ + "img/logo-main.63c4dd4c.png";